<div id="fade-element" className="wrapper">
  <div id="fade-text" className="name-div">
    Darren Sim
  </div>
  <div className="title-div">
    Aspiring Software Engineer & UI/UX Designer
  </div>
  <div className="base-div">
    Based in Singapore
  </div>
  <div className="container">
    <div className="body">
      <div className="display-photo-div">
        <img id="display-photo" src="../../assets/images/darren.jpg" />
      </div>
      <div className="about-div">
        <div className="about-text">
          Hey there! I am Darren Sim, a Penultimate Computer Science Major at National University of Singapore (NUS).
          <br />
          <br />
          My area of expertise is Front-end Development and UI/UX Design, although I sometimes do backend and game development stuff as well. You may
          have a look at the projects I have done so far below.
          <br />
          <br />
          Outside of coding, my other hobbies include Electric Guitar, Amateur Photography and Japanese Culture.
        </div>
      </div>
    </div>
  </div>
  <div className="links-div">
    <div id="resume-btn">
      <a href="https://kalsycdotcom.s3-ap-southeast-1.amazonaws.com/Sim+Jun+Yuen%2C+Darren+Resume+(CAA+221220).pdf">
        <span>My Resume</span>
      </a>
    </div>
  </div>
</div>
